var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 76,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 8,
    y: 10,
    fill: "#fff",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 10h56v20H8z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 8,
    x: 12,
    y: 16,
    fill: "#FFBFA1",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 1,
    x: 12,
    y: 30,
    fill: "#CC3D00",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 8,
    x: 30,
    y: 16,
    fill: "#E3E8EF",
    rx: 1
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 30h56v36H8V30Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 30h56v36H8V30Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E8EF",
    d: "M8 31h56v-2H8v2Z",
    mask: "url(#b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 8,
    y: 10,
    fill: "#fff",
    rx: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.902d280515fd575657e8ccf99545112b.svg";
export { ForwardRef as ReactComponent };